import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/production/cloture")({
  staticData: {
    permission: PERMISSIONS.PRODUCTION.CLOTURE.VIEW,
  },
  component: () => <Outlet />,
});
